import { useState, useEffect } from 'react';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import { getDiasFromFiltro } from '../utils/date';

export const useChartData = (activeTabId, dateFilter, baseURL, startDate, endDate, setForceTokenExpired, alterarDatasEspecificas, setAlterarDatasEspecificas) => {
  const [chartData, setChartData] = useState(null);
  const [loadingChart, setLoadingChart] = useState(false);
  const [error, setError] = useState(null);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (activeTabId === 'dashboard') {
      // Não fazer requisição se for "Datas Específicas" - aguardar botão "Aplicar Filtros"
      if (dateFilter === 'Datas Específicas' && !alterarDatasEspecificas) {
        return;
      }

      // Reset a flag após usar
      if (alterarDatasEspecificas) {
        setAlterarDatasEspecificas(false);
      }

      const fetchChartData = async () => {
        setLoadingChart(true);
        setError(null);

        try {
          const token = localStorage.getItem('jwtToken');
          if (!token) throw new Error("Token não encontrado no localStorage.");

          const decodedToken = jwtDecode(token);
          const idCliente = decodedToken.id_cliente;
          if (!idCliente) throw new Error("ID do cliente não encontrado no token.");

          const dataInicio = startDate;
          const dataFim = endDate;
          const dias = dateFilter === 'Anual' ? null : getDiasFromFiltro(dateFilter);

          const params = {
            idCliente,
            dataInicio,
            dataFim,
            dias,
          };


          console.log("useChartData ", params)

          const response = await axios.get(`${baseURL}/produto/sdr/leads-cliente`, {
            params,
            headers: { Authorization: `Bearer ${token}` }
          });

          setChartData(response.data);
        } catch (error) {

          if (
            error.response?.status === 401 ||
            error.response?.data?.message?.toLowerCase().includes("token") // ou "expired"
          ) {
            setForceTokenExpired(true); // Força abrir o diálogo
          }
        } finally {
          setLoadingChart(false);
        }
      };

      fetchChartData();
    }
  }, [activeTabId, dateFilter, baseURL, startDate, endDate, setForceTokenExpired, alterarDatasEspecificas, setAlterarDatasEspecificas]);

  return { chartData, loadingChart, error };
};

export default useChartData;